import { useState, useRef, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Confetti from "react-confetti";
import "./Draw.scss";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { database } from "../firebaseConfig";
import v_logo from "../Assets/veligaa-logo.png";

function Draw() {
  const [companyLogo, setCompanyLogo] = useState(null);
  const [promoLogo, setPromoLogo] = useState(null);
  const [limit, setLimit] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedTextColor, setSelectedTextColor] = useState(null);
  const [promoTitle, setPromoTitle] = useState("Winner Selection");
  const [allPrizesSelected, setAllPrizesSelected] = useState(false);
  const [selectedPrizeIndices, setSelectedPrizeIndices] = useState([]);

  const [prizes, setPrizes] = useState([
    {
      name: "",
      limit: null,
      winners: [], // Initialize winners array as empty array
    },
  ]);

  const [selectedPrizeIndex, setSelectedPrizeIndex] = useState(null); // Store selected prize index
  const [promoEntries, setPromoEntries] = useState([]);
  const [randomEntry, setRandomEntry] = useState({
    customerName: "",
    couponCode: "",
  });
  const [isScrolling, setIsScrolling] = useState(false);
  const IntervalID = useRef(null);
  const navigate = useNavigate();
  const { title } = useParams();

  const fetchDrawData = async () => {
    try {
      const drawDataRef = doc(database, "Promotions", title);
      const docSnapshot = await getDoc(drawDataRef);
      const data = docSnapshot.data();
      if (data) {
        setCompanyLogo(data.companyLogo);
        setPromoLogo(data.promoLogo);
        setLimit(data.limit);
        setSelectedImage(data.selectedImage);
        setSelectedTextColor(data.selectedTextColor);
        setPrizes(data.prizes);

        // Assuming "entry" field contains the download URL
        const entryDownloadURL = data.entry;

        // Download the CSV file using the URL
        const response = await fetch(entryDownloadURL);
        if (!response.ok) {
          throw new Error("Failed to fetch CSV file");
        }
        const csvData = await response.text();
        // Parse CSV data into an array of entries
        const lines = csvData.split("\n");
        const entries = lines.slice(1).map((line) => {
          const [customerName, couponCode] = line
            .split(",")
            .map((field) => field.trim().replace(/^"(.*)"$/, "$1")); // Remove leading and trailing quotation marks
          return { customerName, couponCode };
        });
        setPromoEntries(entries);
      } else {
        console.error("No data found for the specified title:", title);
      }
    } catch (error) {
      console.error("Error fetching draw data:", error);
    }
  };

  useEffect(() => {
    if (title) {
      fetchDrawData();
    }
  }, [title]);

  const handleCardClick = (index) => {
    setSelectedPrizeIndices((prevIndices) => [...prevIndices, index]);
    setSelectedPrizeIndex(index);
    const selectedPrize = prizes[index];
    setLimit(selectedPrize.limit);
    setPromoTitle(selectedPrize.name);
    setRandomEntry({
      customerName: "",
      couponCode: "",
    });
  };

  const [currentWinners, setCurrentWinners] = useState([]);
  const [currentLimit, setCurrentLimit] = useState();

  // Update currentWinners and limit when the selected prize changes
  useEffect(() => {
    if (selectedPrizeIndex !== null && prizes[selectedPrizeIndex]) {
      setCurrentWinners(prizes[selectedPrizeIndex].winners);
      setCurrentLimit(prizes[selectedPrizeIndex].limit);
    } else {
      setCurrentWinners([]);
      setCurrentLimit(null);
    }
  }, [selectedPrizeIndex, prizes]);

  const startScrolling = () => {
    if (selectedPrizeIndex === null) {
      alert("No selected prize or index");
      return;
    }
    setIsScrolling(true);
    IntervalID.current = setInterval(() => {
      const rand = Math.floor(Math.random() * promoEntries.length);
      setRandomEntry(promoEntries[rand]);
    }, 50);
  };

  const StopScrolling = () => {
    setIsScrolling(false);
    clearInterval(IntervalID.current);
    setCurrentWinners([...currentWinners, randomEntry]); // If you still need a global winners array
    setPromoEntries(promoEntries.filter((entry) => entry !== randomEntry));
    if (selectedPrizeIndex !== null) {
      const updatedPrizes = [...prizes];
      updatedPrizes[selectedPrizeIndex].winners.push(randomEntry);
      setPrizes(updatedPrizes);
    }
  };

  useEffect(() => {
    setAllPrizesSelected((prevAllPrizesSelected) =>
      prizes.every((prize) => prize.winners.length === Number(prize.limit))
    );
  }, [prizes]);

  // Function to reset winners array and random entry
  const handleReset = () => {
    // const initialPrizes = prizes.map((prize) => ({
    //   ...prize,
    //   currentWinners: [],
    // }));
    setCurrentWinners([]);
    // setPrizes(initialPrizes);
    setRandomEntry("Winner Selection!");
  };

  // Function to navigate to winners page
  const navigateToRecord = () => {
    const docRef = doc(database, "Promotions", title);

    const updatedPrizesData = prizes.map((prize) => ({
      ...prize, // Spread individual prize object
      winners: prize.winners, // Update winners field with current winners array
    }));

    updateDoc(docRef, {
      prizes: updatedPrizesData,
    })
      .then(() => {
        console.log("Document successfully updated!");
        navigate(`/record/${title}`);
      })
      .catch((error) => {
        console.error("Error updating document: ", error);
      });
    navigate(`/record/${title}`);
  };

  return (
    <div
      className="draw-container"
      // style={{ backgroundImage: `url(${selectedImage})` }}
    >
      <div className={`prize-div  ${allPrizesSelected ? "no-show" : ""}`}>
        <h2 className={`msg  ${allPrizesSelected ? "full" : ""}`}>
          Choose a prize to find the lucky winners!
        </h2>
        {prizes.map((item, index) => (
          <div
            className={`prize-card ${
              selectedPrizeIndices.includes(index) ? "selected" : ""
            }`}
            key={index}
            onClick={() => handleCardClick(index)}
          >
            <a>
              <h1 className="prize-name">
                {item.name} x{item.limit}
              </h1>
            </a>
            {/* <h1>{item.limit}</h1> */}
          </div>
        ))}
      </div>

      <span className={`big-section  ${allPrizesSelected ? "fullScreen" : ""}`}>
        <div className="draw-content" style={{ color: selectedTextColor }}>
          <div className="logo-div">
            <img src={v_logo} alt="" className="logo" />
          </div>
          {/* adapted for veligaa draw */}
          {/* <div className="logoContainer">
          
          <div className="c-logo">
            <img src={companyLogo} alt="" className="companyLogo" />
          </div>
          <div className="p-logo">
            <img src={promoLogo} alt="" className="promoLogo" />
          </div> 
        </div>*/}

          <h1 className="promoTitle">{title}</h1>
          {selectedPrizeIndex !== null ? (
            <h1 className="promo-title">{promoTitle}</h1>
          ) : (
            ""
          )}

          <div className="output-container">
            {isScrolling ? (
              <div className="output">
                <p>
                  {randomEntry.customerName} - {randomEntry.couponCode}
                </p>
              </div>
            ) : currentWinners.length >= currentLimit ? (
              ""
            ) : (
              <div className="output">
                {(randomEntry && (
                  <p>
                    {randomEntry.customerName} - {randomEntry.couponCode}
                  </p>
                )) ||
                  "Winner Selection!"}
              </div>
            )}
          </div>

          {/* <div className="winnersDiv">
          <ul className={currentWinners.length === limit ? "up" : "stay"}>
            {currentWinners.map((entry, index) => (
              <li key={entry}>
                {entry} {index}
              </li>
            ))}
          </ul>
        </div> */}

          <div className="winnersDiv">
            <ul
              className={currentWinners.length >= currentLimit ? "up" : "stay"}
            >
              {currentWinners.map((winner, index) => (
                <li key={index}>
                  {/* Render customer name and coupon code */}
                  {winner.customerName} - {winner.couponCode}
                </li>
              ))}
            </ul>
          </div>

          {selectedPrizeIndex !== null &&
          selectedPrizeIndex !== undefined &&
          currentWinners.length !== currentLimit ? (
            <button
              className="button stopbtn"
              style={{ backgroundColor: selectedTextColor }}
              onClick={
                isScrolling
                  ? () => StopScrolling()
                  : () => startScrolling(selectedPrizeIndex)
              }
              disabled={currentWinners.length >= currentLimit}
            >
              {isScrolling ? "Stop" : "Draw"}
            </button>
          ) : (
            "Select a prize to find the lucky winners!"
          )}

          <button
            className="button recsbtn"
            style={{ backgroundColor: selectedTextColor }}
            disabled={!allPrizesSelected}
            onClick={navigateToRecord}
          >
            Winners Page
          </button>

          {currentWinners.length > 0 && (
            <button
              className="button resetbtn"
              style={{ backgroundColor: selectedTextColor }}
              onClick={handleReset}
            >
              Reset
            </button>
          )}
        </div>

        <div className="confetti">
          {currentWinners.length !== 0 &&
            currentWinners.length >= currentLimit && <Confetti />}
        </div>
      </span>
    </div>
  );
}

export default Draw;
